import { Box, Typography } from "@mui/material";
import { formatDate } from "../../../utils/dateUtils";
import { renderFieldView } from "../../../components/fieldsViews/renderFieldView";
import { RelatedRecordsContext } from "../../../components/recordsRelated/RecordsRelated";
import { useContext } from "react";
import { findField } from "../../../utils/findField";
import { formatClientName } from  "./utils"

export type RenderOrderAssociateOptionProps = {
    props: any;
    option: any;
};

export const RenderOrderAssociateOption = ({ props, option }: RenderOrderAssociateOptionProps) => {
    const relatedRecordsContext = useContext(RelatedRecordsContext);
    const paymentField = relatedRecordsContext?.formatedFields ? findField(relatedRecordsContext.formatedFields, "payment_method") : null;
    const clientName = formatClientName(option?.order?.treatment?.client?.user_id?.first_name || "", option?.order?.treatment?.client?.user_id?.last_name || "");

    return (
        <Box {...props} sx={{ display: "flex", gap: 2 }}>
            <Typography variant="inherit">{formatDate(option?.payment_date || "")}:</Typography>
            <Typography variant="body1">{option?.order?.treatment?.client?.client_id || ""}</Typography>
            <Typography variant="body1">{clientName}</Typography>
            <Typography variant="body1">{option?.amount || 0} €</Typography>
            {paymentField && renderFieldView(paymentField, option, "group")}
        </Box>
    );
};
